import { Modal } from "react-bootstrap";
import { AiOutlineSend } from "react-icons/ai";
import SyncFusionDateTimePicker from "../../../../SyncFusionDateTimePicker/SyncFusionDateTimePicker";
import { usePermissions } from "../../../../../../contexts/PermissionsContext";

export const MaintenanceModal = ({
  show,
  onHide,
  localUnderMaintenance,
  maintenanceMessage,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onSubmit,
}) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Informar manutenção</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {maintenanceMessage && (
        <p style={{ color: "var(--text-success)", fontWeight: "600", margin: "0 0 8px", fontSize: "0.9rem" }}>
          {maintenanceMessage}
        </p>
      )}
      {localUnderMaintenance !== "S" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16, margin: 8 }}>
          <p style={{ color: "var(--text-primary)", margin: 0 }}>Data de manutenção</p>
          <SyncFusionDateTimePicker
            id="datetimepickerStart"
            value={startDate}
            placeholder="Horário Inicial"
            onChange={onStartDateChange}
            localUnderMaintenace={localUnderMaintenance}
          />
          <SyncFusionDateTimePicker
            id="datetimepickerEnd"
            value={endDate}
            placeholder="Horário final"
            onChange={onEndDateChange}
            localUnderMaintenace={localUnderMaintenance}
          />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <button
          type="button"
          className="btn btn-outline-secondary"
          style={{ color: "var(--text-primary)", borderColor: "var(--text-primary)" }}
          onClick={onSubmit}
          disabled={localUnderMaintenance === "N" && !endDate}
        >
          {localUnderMaintenance === "S" ? "Retirar" : "Registrar"}
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export const CommandsModal = ({
  show,
  onHide,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onSearch,
}) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Histórico de comandos</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p style={{ color: "var(--text-primary)" }}>Buscar por:</p>
      <div style={{ display: "flex", flexDirection: "column", gap: 16, margin: 8 }}>
        <SyncFusionDateTimePicker
          id="commandsStart"
          value={startDate}
          placeholder="Horário Inicial"
          onChange={onStartDateChange}
        />
        <SyncFusionDateTimePicker
          id="commandsEnd"
          value={endDate}
          placeholder="Horário final"
          onChange={onEndDateChange}
        />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            style={{ color: "var(--text-primary)", borderColor: "var(--text-primary)" }}
            onClick={() => onSearch(startDate, endDate)}
            disabled={endDate < startDate}
          >
            Buscar
          </button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

export const AvailableCommandsModal = ({ show, onHide, commands, onSendCommand }) => {
  const { canExecuteCommand } = usePermissions();

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Comandos disponíveis</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-grid" id="paginated-table">
          <thead>
            <tr>
              <th>Comando</th>
              {canExecuteCommand && <th>Enviar</th>}
            </tr>
          </thead>
          <tbody className="table-border-bottom-0">
            {commands?.map((item, index) => (
              <tr key={index}>
                <td>{item.descriptionCommand}</td>
                {canExecuteCommand && (
                  <td>
                    <AiOutlineSend cursor="pointer" onClick={() => onSendCommand(item)} />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};

export const ConfirmCommandModal = ({ show, onHide, command, vehicleName, onConfirm }) => {
  const { canExecuteCommand } = usePermissions();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar envio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: "var(--text-primary)" }}>
          Você tem certeza do envio do comando{" "}
          <strong>{command?.descriptionCommand}</strong> para o veículo{" "}
          <strong>{vehicleName}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Cancelar
        </button>
        {canExecuteCommand && (
          <button type="button" className="btn btn-primary" onClick={onConfirm}>
            Enviar comando
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
